import { DashboardIcon } from '@carboncopyco/icons';
import type { AvatarSize } from '@carboncopyco/ui';
import { avatarSizes, squaredRadiuses } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import classNames from 'classnames';

type WelcomeScreenButtonProps = {
  isSelected?: boolean;
  onClick: () => void;
  size?: AvatarSize;
};

export const WelcomeScreenButton = ({
  isSelected = false,
  onClick,
  size = 'medium',
}: WelcomeScreenButtonProps) => {
  const [hover, { setTrue: setTrueHover, setFalse: setFalseHover }] =
    useBoolean(false);

  return (
    <div
      onMouseEnter={setTrueHover}
      onMouseLeave={setFalseHover}
      data-testid="dashboardButton"
      className={classNames(
        'flex items-center justify-center border border-transparent box-border',
        avatarSizes[size],
        squaredRadiuses[size],
        {
          'text-ds-accent3-100 bg-ds-natural-700 pointer-events-none':
            isSelected,
          'text-ds-natural-600': !isSelected,
          'bg-ds-natural-150 cursor-pointer': hover && !isSelected,
        }
      )}
    >
      <div onClick={onClick}>
        <DashboardIcon />
      </div>
    </div>
  );
};
